
// this file is automatically generated by config/version.ts script
export const version = {
	version: '3.0.cc4a8fe.2267'
};
